import { Form } from "react-bootstrap";

const DropdownInput = (props) => {
    return (
        <Form.Group>
            <Form.Label>{props.required && '*'} {props.label}</Form.Label>
            <Form.Select {...props.register} aria-label="Default select example" onChange={props.handleDropdownSelect} disabled={props.disabled}>
                {/* <option value=''>--Select one--</option> */}
                {props.items && props.items.map((item, i) => (<option key={i} value={item.value}>{item.label}</option>))}
            </Form.Select>
            <Form.Control.Feedback type="invalid" style={props.errors ? {display: 'block'} : {display: 'none'}}>This field is required</Form.Control.Feedback>
        </Form.Group>
    )
}

export default DropdownInput;